/**
 * LEARNING-HOME.WIDGET
 * Display learning (iframe idtree v1)
 */

function LearningHomeWidget() {
  return (
    <iframe
      title="learning"
      style={{
        width: "100%",
        height: "calc(100vh - 60px)",
        position: "fixed",
        top: 48,
        left: 0
      }}
      src="https://coaching.id-tree.com/#!/_login/coaching/1dbad5e4-93d4-4d85-871a-21dc9a17a0ad/null/"></iframe>
  )
}
export default LearningHomeWidget
